import axios from "@/utils/axios";
import {
    AssetMaterializationResult,
    EditorialAsset,
    OverlayRenderParametersResponse
} from "@/types/editorialAssetsTypes";

export async function getEditorialAssets(contentType: string, competitionId?: string,): Promise<EditorialAsset[]> {
    const response = await axios.post(`/editorial_asset/v2`, {competitionId, contentType});
    return response.data;
}

export async function getAssetDefaultRenderParameters(editorialAssetId: string, params: any): Promise<OverlayRenderParametersResponse> {
    const response = await axios.post(`/editorial_asset/v2/render_parameters`, {...params, overlay_id: editorialAssetId});
    return response.data;
}

// Il form del campo testo (EditorAssetForm) scrive sotto la chiave dello schema (es. "Label"),
// mentre la generazione automatica del nome evento scrive sotto "label" minuscolo: senza questa
// normalizzazione entrambe le chiavi finiscono nel payload e il backend può leggere quella sbagliata.
function normalizeOverlayParams(params: any): any {
    if (!params || typeof params !== "object" || !("Label" in params)) return params;
    const { Label, ...rest } = params;
    return { ...rest, label: Label };
}

export async function materializeEditorialAsset(editorialAssetId: string, editorialAssetParams: any, materializationParms: any): Promise<AssetMaterializationResult> {
    const response = await axios.post(`/editorial_asset/v2/materialize`, {
        ...editorialAssetParams,
        overlay_params: normalizeOverlayParams(materializationParms),
        overlay_id: editorialAssetId
    });
    return response.data;
}
